export default "__VITE_ASSET__B8IHbr9e__"